import React, { createContext, useContext, useState } from "react";

// Create the context
const PolygonHoleContext = createContext();

// Custom hook to use the context
export const usePolygonHole = () => {
  const context = useContext(PolygonHoleContext);
  if (!context) {
    throw new Error("usePolygonHole must be used within a PolygonHoleProvider");
  }
  return context;
};

// Provider component
export const PolygonHoleProvider = ({ children }) => {
  const [shouldCutHole, setShouldCutHole] = useState(false);

  const value = {
    shouldCutHole,
    setShouldCutHole,
  };

  return (
    <PolygonHoleContext.Provider value={value}>
      {children}
    </PolygonHoleContext.Provider>
  );
};

export default PolygonHoleProvider;
